'use client';

import { Box, IconButton, Typography } from '@mui/material';
import { Center } from '@ocodelib/mui';
import { sxAbsolute } from '@repo-foundation/util/sx-util';
import {
  AiTrainGuideDialog,
  type AiTrainGuideDialogProps,
} from '@repo-ui/dialogs/AiTrainGuideDialog';
import { AiLearnListLayout } from '@repo-ui/layout/AiLearnListLayout';
import MainLayout from '@repo-ui/layout/MainLayout';
import dynamic from 'next/dynamic';
import NextImage from 'next/image';
import { useState } from 'react';

type DialogParams = {
  id: 'AItrainGuideDialog';
  props: AiTrainGuideDialogProps;
};

// 생성 모델 목록
const SupervisedList = dynamic(() =>
  import('@/features/ai-learn-list/supervised/SupervisedList').then((m) => m.SupervisedList),
);

export default function Page() {
  return (
    <MainLayout>
      <AiLearnListLayout
        tab="supervised"
        title={<Title />}
        sx={{
          '& .AiLearnListLayout-myModelBtn': {
            ...sxAbsolute({ top: 0, right: 0 }),
          },
        }}
      >
        <SupervisedList />
      </AiLearnListLayout>
    </MainLayout>
  );
}

function Title() {
  const [dialogParams, setDialogParams] = useState<DialogParams | undefined>(undefined);
  const openAItrainGudieDialog = () => {
    setDialogParams({
      id: 'AItrainGuideDialog',
      props: {
        open: true,
        onClose: () => {
          setDialogParams(undefined);
        },
        kind: 'SUPERVISED',
      },
    });
  };

  return (
    <Center>
      <Box sx={{ position: 'relative' }}>
        <Typography variant="h5" mr={1} sx={{ fontSize: '1.5rem' }}>
          지도학습이란
        </Typography>

        <IconButton
          onClick={openAItrainGudieDialog}
          size="small"
          sx={{
            ...sxAbsolute({ top: 0, right: -30 }),
            ':hover': {
              backgroundColor: '#fff8e1',
            },
          }}
        >
          <NextImage src="/_static/images/icon_bulb.svg" width={22} height={22} alt="" />
        </IconButton>
      </Box>
      {dialogParams?.id === 'AItrainGuideDialog' && <AiTrainGuideDialog {...dialogParams.props} />}
    </Center>
  );
}
